import useSWR from 'swr';
import { useNavigate } from 'react-router-dom';
import { fetcher } from '@/utils/apiService';
import { cookieUtils } from '@/utils/cookieUtils';

export const useProfile = () => {
    const navigate = useNavigate();
    const token = cookieUtils.getAuthToken();

    const { data, error, isLoading, mutate, isValidating } = useSWR(
        token ? '/profile' : null,
        fetcher,
        {
            onError: (err) => {
                if (err?.statusCode === 401 || err?.statusCode === 403) {
                    console.warn('Unauthorized access detected. Clearing cookies and redirecting...');
                    cookieUtils.clearAllAuthCookies();
                    navigate('/', { replace: true });
                }
            },
            // Disable all retries on error
            onErrorRetry: () => {
                return;
            },
            revalidateOnFocus: !!token,
            revalidateOnReconnect: !!token,
        }
    );

    return {
        profile: data?.data,
        isLoading,
        isError: error,
        mutate, // Use this to manually refresh profile data
        isValidating,
        rawData: data // Access full response if needed
    };
};


export const useDocuments = () => {
    const navigate = useNavigate();
    const token = cookieUtils.getAuthToken();

    const { data, error, isLoading, mutate, isValidating } = useSWR(
        token ? '/documents' : null,
        fetcher,
        {
            onError: (err) => {
                if (err?.statusCode === 401 || err?.statusCode === 403) {
                    console.warn('Unauthorized access detected. Clearing cookies and redirecting...');
                    cookieUtils.clearAllAuthCookies();
                    navigate('/', { replace: true });
                }
            },
            onErrorRetry: () => {
                return;
            },
            revalidateOnFocus: !!token,
            revalidateOnReconnect: !!token,
        }
    );

    return {
        document: data?.data,
        isLoading,
        isError: error,
        mutate, // Use this to manually refresh profile data
        isValidating,
        rawData: data // Access full response if needed
    };
};


